import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { handleUnauthorized } from '../../TokenAuth/auth';

const initialState = {
  data: [],
  status: 'idle',
  error: null,
  paginationDetail: {
    totalDocs: 0,
    totalPages: 0,
    page: 1,
    limit: 10,
  },
};

export const fetchAstroEarningHistory = createAsyncThunk(
  'astroEarning/fetchAstroEarningHistory',
  async (params, { rejectWithValue }) => {
    const token = localStorage.getItem('astroVani-admin-token');
    if (!token) {
      return rejectWithValue('Authorization token not found');
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/astroEarningHistory`,
        {
          params,
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
       if (error.response?.status === 401) {
        handleUnauthorized();
      }
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const astroEarningHistorySlice = createSlice({
  name: 'astroEarningHistory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAstroEarningHistory.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAstroEarningHistory.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.data || [];
        state.paginationDetail = action.payload.paginationDetail || initialState.paginationDetail;
      })
      .addCase(fetchAstroEarningHistory.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default astroEarningHistorySlice.reducer;
